let tinycolor = require('tinycolor2')

export default {
  fromExtension (extension, s, v) {
    let hue = 0
    switch (extension) {
      case 'DOC':
      case 'DOCX':
        hue = 252
        break
      case 'XLS':
      case 'XLSX':
        hue = 126
        break
      case 'PDF':
        hue = 0
        break
      default:
        for (let i = 0; i < extension.length; i++) {
          hue += (extension.charCodeAt(i) - 65) * 10
        }
        hue %= 28
        hue *= 10
        hue %= 255
    }
    return tinycolor({h: hue, s: s || 92, v: v || 40}).toHexString()
  },
  fromType (type, color, s, v) {
    if (color) {
      let hue = 0
      if (typeof color === 'string') {
        hue = tinycolor(color).toHsv().h
      } else {
        hue = color
      }
      return tinycolor({h: hue, s: s || 67, v: v || 92}).toHexString()
    } else {
      return '#9b9b9b'
    }
  },
  fromName (name, s, v) {
    let hue = 0
    name = name.toUpperCase()
    for (let i = 0; i < name.length; i++) {
      hue += (name.charCodeAt(i) - 65)
    }
    hue %= 28
    hue *= 10
    hue %= 255
    return tinycolor({h: hue, s: s || 80, v: v || 80}).toHexString()
  }
}



// WEBPACK FOOTER //
// ./src/helpers/color.js